import { HttpException } from './http-exception';

export class NetworkRequestTimeoutException extends HttpException {
  private readonly _requestCached: boolean;

  constructor(status?: number, requestCached?: boolean, ...params) {
    super(status, ...params);

    this._requestCached = requestCached;
  }

  isRequestCached(): boolean {
    return this._requestCached;
  }
}
